import * as React from "react";

import { ConnectShopifyCallout } from "@editor/components/editor/page/ConnectShopifyCallout";
import { useModal } from "@editor/hooks/useModal";

import { Modal } from "@replo/design-system/components/modal/Modal";

export const RefreshShopifyIntegrationAnalyticsModal: React.FC<{
  workspaceId: string | undefined;
  projectId: string | undefined;
  experimentId: string | undefined;
}> = ({ projectId, experimentId, workspaceId }) => {
  const { closeModal } = useModal();
  return (
    <Modal
      isOpen={true}
      onOpenChange={(open) => {
        if (!open) {
          closeModal({ type: "refreshShopifyIntegrationAnalyticsModal" });
        }
      }}
      title="Connect to See Results"
      description="To see your A/B test results, you must be testing pages connected to a Shopify store."
      size="sm"
    >
      {projectId && (
        <ConnectShopifyCallout
          cookieValue={{
            type: "abtesting",
            projectId,
            experimentId,
            workspaceId,
          }}
        />
      )}
    </Modal>
  );
};
